import axios from "@/utils/axios";

export default {
	async userLogin(): Promise<string> {
		return (await axios().get("/auth/")).data;
	},
	async logout(): Promise<void> {
		return (await axios().get("/auth/logout/")).data;
	},
	async userDiscordLogin(): Promise<string> {
		return (await axios().get("/auth/discord/")).data;
	},
	async discordDisconnect(): Promise<void> {
		return (await axios().get("/auth/discord/disconnect")).data;
	},
};
